import React, { useContext, useState } from 'react';
import { AppContext } from '~/providers/AppProvider';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { SearchCalendar, Button } from '@boatsetter-backup/js-component-lib';
import moment from 'moment';
import { Trans } from '@lingui/react';
import { getCultureToken } from '~/utils/langUtils';

const DateFilter = ({ setShowDateFilter }) => {
  const router = useRouter();
  const appCtx = useContext(AppContext);
  const [selectedDate, setSelectedDate] = useState(
    router.query.availableFrom !== undefined ? moment(router.query.availableFrom) : undefined
  );

  const [renderedDate, setRenderedDate] = useState(
    selectedDate != null ? moment(selectedDate, 'YYYY-MM-DD') : moment()
  );

  const chooseDate = (date) => {
    setSelectedDate(date);
    setRenderedDate(date);
  };

  const pushDate = () => {
    setShowDateFilter(false);
    appCtx.actions.setLoading(true);

    const currentQueries = router.query;
    delete currentQueries.pageNumber;

    router.replace(
      {
        pathname: `/${getCultureToken(appCtx)}search`,
        query: {
          ...currentQueries,
          availableFrom: selectedDate.toISOString(),
        },
      },
      undefined,
      { scroll: false }
    );
  };

  const clearDate = () => {
    setShowDateFilter(false);

    setSelectedDate(moment());
    const currentQueries = router.query;

    delete currentQueries.availableFrom;
    delete currentQueries.pageNumber;

    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...currentQueries,
        },
      },
      undefined,
      { scroll: false }
    );
  };

  return (
    <Wrapper>
      <CalendarWrapper>
        <FiltersWrapper>
          <SearchCalendar
            allowFuture
            blockedDates={[]}
            bottomComponents={{}}
            dayNameShortcuts={['S', 'M', 'T', 'W', 'T', 'F', 'S']}
            hideNextMonthArrow
            hidePrevMonthArrow
            localeShortcut={appCtx.state.lang}
            numMonthsToShow={1}
            onDateClick={chooseDate}
            onMonthChange={(month) => {
              setRenderedDate(month);
            }}
            renderedDate={renderedDate}
            selectedDate={selectedDate}
            showHeader
            showOverlay
          />
        </FiltersWrapper>

        <FilterBottomBar>
          <Clear onClick={clearDate}>
            Clear date
            {/* <Trans id='moreFilters.clearAll' /> */}
          </Clear>
          <Button small={true} onClick={pushDate} text={<Trans id="moreFilters.seeResults" />} />
        </FilterBottomBar>
      </CalendarWrapper>
    </Wrapper>
  );
};

export default DateFilter;

const CalendarWrapper = styled.div`
  /* position: absolute;
    width: 300px;
    top: 20px;
    background-color: white;
    left: -70px; */
  display: flex;
  flex-direction: column;
`;

const FiltersWrapper = styled.div`
  padding: 30px;

  button {
    background: transparent;
    outline: none;
    border: none;
  }
`;

const Wrapper = styled.div`
  position: relative;
  width: 350px;
  position: absolute;
  background-color: white;
  border: 1px solid #dbdfe5;
  box-sizing: border-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  top: 55px;

  @media (max-width: 960px) {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    width: 92%;
    overflow-x: hidden;
  }
`;

const FilterBottomBar = styled.div`
  height: 90px;
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 5px 22px -2px rgba(0, 0, 0, 0.2);
  padding: 2em;

  button span {
    font-size: 12px !important;
    font-family: AvenirNext, Avenir, Helvetica Neue, Helvetica, Arial, sans-serif;
  }
`;

const Clear = styled.div`
  font-size: 1em;
  line-height: 1.6;
  color: #0751c2;
  cursor: pointer;
`;
